//@flow
import { gql, graphql } from "react-apollo"
import type { UserFormViewProps } from "../types"

const QUERY_USER_DETAILS = gql`
  query GetUserDetails($id: ID!) {
    user(id: $id) {
      id
      name
      email
      admin
    }
  }
`
const skip = (props: UserFormViewProps): boolean =>
  typeof props.match.params.id === "undefined"

const options = (props: UserFormViewProps) => ({
  variables: {
    id: props.match.params.id
  }
})

const withUserFormDetails = graphql(QUERY_USER_DETAILS, {
  options,
  skip,
  name: "details"
})

export default withUserFormDetails



// WEBPACK FOOTER //
// ./src/Users/queries/withUserFormDetails.js